import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { MuiThemeProvider as MuiNextThemeProvider } from '@material-ui/core/styles';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import designBaseTheme from 'fe-design-base/styles/theme';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import muiTheme from 'theme/mui';
import muiNextTheme from 'theme/muiNext';

import Paywalls from 'features/productGrowth/Paywalls/Paywalls';

import { browserHistory } from 'util/router';

const PaywallsRootModal = ({
  tier,
  feature,
  focusedFeature,
  onClose,
  serverKey,
  locationProperty,
  store,
}: {
  tier: string;
  feature: string;
  focusedFeature?: string;
  onClose: () => void;
  serverKey?: string;
  locationProperty?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  store: any;
}) => (
  <MuiNextThemeProvider theme={muiNextTheme}>
    <MuiThemeProvider muiTheme={muiTheme}>
      <ThemeProvider theme={designBaseTheme}>
        <StyledEngineProvider>
          <Provider store={store}>
            <Router history={browserHistory}>
              <Paywalls
                tier={tier}
                feature={feature}
                focusedFeature={focusedFeature}
                onClose={onClose}
                serverKey={serverKey}
                locationProperty={locationProperty}
              />
            </Router>
          </Provider>
        </StyledEngineProvider>
      </ThemeProvider>
    </MuiThemeProvider>
  </MuiNextThemeProvider>
);

export default PaywallsRootModal;
